import { TabMenu, TabMenuContent, TabMenuList, TabMenuTrigger } from '@ads/components-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { ExamEditTab } from '../../../store/atoms/examEditAtom';

export interface ExamDetailTabsProps {
  readonly activeTab: ExamEditTab;
  readonly onTabChange: (tab: ExamEditTab) => void;
  readonly children: ReactNode;
}

const TABS: ExamEditTab[] = ['general', 'languages', 'questions', 'publications'];

export function ExamDetailTabs({ activeTab, onTabChange, children }: ExamDetailTabsProps) {
  const { t } = useTranslation('examManagement');

  return (
    <TabMenu
      className="w-full"
      value={activeTab}
      onValueChange={v => onTabChange(v as ExamEditTab)}
    >
      <TabMenuList className="w-full">
        {TABS.map(tab => (
          <TabMenuTrigger className="w-full" key={tab} value={tab}>
            {t(`editTabs.${tab}` as never)}
          </TabMenuTrigger>
        ))}
      </TabMenuList>
      <TabMenuContent value={activeTab}>
        <div className="pt-md">{children}</div>
      </TabMenuContent>
    </TabMenu>
  );
}
